import { Check } from '@aktiia/design-system';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalName } from '../../../../enums';
import { useCopyToClipboard } from '../../../../features/app';
import { useOrganization } from '../../../../features/organization';
import { Button, Modal } from '../../../common';

export const InvitePatientModal = () => {
  const { t } = useTranslation();
  const { organization } = useOrganization();
  const lng = useMemo(() => (organization?.language === 'italian' ? 'it' : undefined), [organization]);
  const text = useMemo(
    () => `
    ${t('modal.invite.message.salutation', { lng })},
    ${organization?.name} ${t('modal.invite.message.content', { lng })} ${organization?.linkageKey}.
    ${organization?.consentFormUrl}
    -
    ${organization?.name}
  `,
    [organization],
  );

  const [isCopied, copyText] = useCopyToClipboard(text);
  const buttonText = useMemo(
    () => (isCopied ? t('modal.invite.label.copied') : t('modal.invite.button.copy')),
    [isCopied],
  );

  return (
    <Modal name={ModalName.INVITE_PATIENT} header={t('modal.invite.title')}>
      <p className="typography-paragraph-3 text-text-secondary">{t('modal.invite.description')}</p>

      <div className="p-4 mt-6 typography-paragraph-3 bg-global-neuchatel-20 rounded-tr-3xl rounded-br-3xl rounded-bl-3xl">
        {t('modal.invite.message.salutation', { lng })},
        <br />
        <br />
        <b>{organization?.name}</b> {t('modal.invite.message.content', { lng })} <b>{organization?.linkageKey}</b>.
        <br />
        <br />
        <a className="typography-inline-link-3 text-text-link cursor-pointer" href={organization?.consentFormUrl}>
          {organization?.consentFormUrl}
        </a>
        <br />
        <br />
        -
        <br />
        {organization?.name}
      </div>

      <Button
        text={buttonText}
        className="mt-6"
        leftIcon={isCopied && <Check className="scale-75" />}
        onClick={copyText}
      />
    </Modal>
  );
};
